var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();return _vm.leaveImpersonation.apply(null, arguments)}}},[(_vm.hasIcon)?_c('span',{staticClass:"icon icon-eye-slash icon-lg icon-fw"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.$t('users.leave_impersonation'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }